import * as React from "react";
import ContactLayout from "./ContactLayout";

export const ContactBrokers = () => {
  return (
    <ContactLayout
      description="Say transforms shareholder communications from a compliance function into a client acquisition and engagement opportunity."
      formPortalId="4597759"
      formId="33798bf1-8fce-4acb-a8da-aef82f37a787"
      title={
        <h1>
          Say
          <sup>&#174;</sup> for Brokers
        </h1>
      }
      siteTitle="Say for Brokers"
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/Contact/ContactBrokers.tsx